import React, {useEffect} from "react";
import useState from "react-usestateref";
import {Button} from "@material-ui/core";
import {get_Book_List} from "../config/apiCall";
import {downloadersDetails} from "../config/apiCall";
import httpService from "../config/httpCall";
import {toastAlert} from "../config/toastAlert";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import {Link, useNavigate, Redirect} from "react-router-dom";
function Book() {
  const initialFormValue = {
    downloaderName: "",
    downloaderEmail: "",
    downloaderNumber: "",
    downloaderCountry: "",
    downloaderId: "",
  };

  const [formValue, setFormValue] = useState(initialFormValue);
  var [bookDetails, setBookDetails] = useState([]);
  var [bookId, setBookId] = useState("");
  var [bookName, setBookName] = useState("");
  var [bookImage, setBookImage] = useState("");
  var [bookDescription, setBookDescription] = useState("");
  var [downloaderNumber, setDownloaderNumber] = useState("");
  var [downloaderDetails, setDownloaderDetails] = useState("false");
  var [
    downloaderNameErr,
    setdownloaderNameErr,
    setdownloaderNameErrref,
  ] = useState(false);
  var [
    downloaderEmailErr,
    setdownloaderEmailErr,
    setdownloaderEmailErrref,
  ] = useState(false);
  var [
    downloaderNumberErr,
    setdownloaderNumberErr,
    setdownloaderNumberErrref,
  ] = useState(false);
  var [
    downloaderCountryErr,
    setdownloaderCountryErr,
    setdownloaderCountryErrref,
  ] = useState(false);
  var [downloaderIdErr, setdownloaderIdErr] = useState(false);
  var [downloaderNumberErr, setdownloaderNumberErr] = useState(false);
  var [vallidationErr, setVallidationErr] = useState(false);
  var [pdf, setPdf] = useState("");
  const {
    downloaderName,
    downloaderEmail,
    downloaderCountry,
    downloaderId,
  } = formValue;
  useEffect(() => {
    getBookList(0);
  }, [0]);

  const getBookList = async () => {
    var data = {
      apiUrl: httpService.getBookList,
    };
    var resp = await get_Book_List(data);
    console.log(resp.Message.book_Details, "respresp");
    setBookDetails(resp.Message.book_Details);
    setBookDetails(resp.Message.book_Details);
  };
  const handleChange = async (e) => {
    try {
      e.preventDefault();
      const {name, value} = e.target;
      let formData = {...formValue, ...{[name]: value}};
      setFormValue(formData);
      console.log("formVlau", formValue);
    } catch (error) {}
  };
  const viewBook = async (item) => {
    console.log(item._id);
    setDownloaderDetails(true);
    setBookId(item._id);
    setBookName(item.bookTitle);
    setBookImage(item.coverImage);
    setBookDescription(item.bookDescription);
    setPdf(item.bookPdf);
    console.log(item.bookPdf);

    console.log(pdf);
  };

  const vallidation = async () => {
    try {
      const error = {};
      if (formValue.downloaderName == "") {
        setdownloaderNameErr(true);
        error.downloaderName = "Must Enter Your Name";
      } else {
        setdownloaderNameErr(false);
      }
      if (formValue.downloaderEmail == "") {
        setdownloaderEmailErr(true);
        error.downloaderEmail = "Must Enter Your Email";
      } else if (
        !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(
          formValue.downloaderEmail
        )
      ) {
        setdownloaderEmailErr(true);
        error.downloaderEmail = "Invalid Email Address";
      } else {
        setdownloaderEmailErr(false);
      }
      if (formValue.downloaderCountry == "") {
        setdownloaderCountryErr(true);
        error.downloaderCountry = "Must Enter Your Country";
      } else {
        setdownloaderCountryErr(false);
      }
      if (downloaderNumber == "") {
        setdownloaderNumberErr(true);
        error.downloaderNumber = "Must Enter Your Number";
      } else {
        setdownloaderNumberErr(false);
      }
      if (formValue.downloaderId == "") {
        setdownloaderIdErr(true);
        error.downloaderId = "Must Enter Your Any Id";
      } else {
        setdownloaderIdErr(false);
      }

      setVallidationErr(error);
    } catch (error) {}
  };

  const Submit = async (e) => {
    e.preventDefault();
    // vallidation(formValue);
    // if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(formValue.downloaderEmail)) {
    // } else {
    // if (
    //   setdownloaderNameErrref.current==false&&
    //   setdownloaderEmailErrref.current==false&&
    //   setdownloaderNumberErrref.current==false&&
    //   setdownloaderCountryErrref.current==false &&
    //   downloaderNumber != undefined
    //   )
    //  {
    formValue["downloaderNumber"] = downloaderNumber;
    formValue["bookId"] = bookId;
    formValue["bookName"] = bookName;
    console.log(formValue);

    var obj = {
      apiUrl: httpService.downloader_Details,
      payload: formValue,
    };
    console.log(obj, "obj");
    var resp = await downloadersDetails(obj);
    if (resp.status) {
      toastAlert("success", resp.Message);
      console.log(resp.Message, "obj");

      //const PDF = [`http://localhost:3001/${pdf}`];
      const PDF = [`https://beleaftechnologies.com:3001/${pdf}`];

      console.log(pdf);
      const file = new Blob(PDF, {type: "application/pdf"});
      const element = document.createElement("a");
      element.href = PDF;
      element.download = PDF;
      document.body.appendChild(element);
      element.click();
      // }
    }
  };

  return (
    <>
      {bookDetails &&
        bookDetails.map((item, i) => {
          return (
            <div className="col-lg-12">
              <div className="col-lg-4 col-md-6">
                <div className="card_service">
                  <div className="icon">
                    <img
                      src={item.coverImage}
                      className="icon_serveice"
                      alt="Centralized Crypto Exchange Development"
                    />
                  </div>
                  <div className="content">
                    <h4>{item.bookTitle}</h4>
                    <p>{item.bookDescription}</p>
                    <Link>
                      <Button onClick={(e) => viewBook(item)}>
                        <i className="bi bi-arrow-right"></i>
                      </Button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          );
        })}

      {downloaderDetails == true ? (
        <div className="row">
          <div className="col-lg-8 padid_a00">
            <div className="CTA_card_pop">
              <form>
                <div className="form-group row">
                  <div className="col-sm-6 pt-3 pb-3">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Name"
                      name="downloaderName"
                      value={downloaderName}
                      onChange={handleChange}
                    />
                    {downloaderNameErr && downloaderNameErr === true ? (
                      <span className="text-danger">
                        {" "}
                        {vallidationErr.downloaderName}{" "}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-sm-6  pt-3 pb-3">
                    <input
                      type="email"
                      className="form-control"
                      id="inputPassword"
                      placeholder="Email"
                      name="downloaderEmail"
                      value={downloaderEmail}
                      onChange={handleChange}
                    />
                    {downloaderEmailErr && downloaderEmailErr === true ? (
                      <span className="text-danger">
                        {" "}
                        {vallidationErr.downloaderEmail}{" "}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-sm-6  pt-3 pb-3">
                    <div className=" react-tel-input d-flex flex-column align-items-start">
                      <div className="special-label">Phone</div>
                      <PhoneInput
                        country={"us"}
                        value={downloaderNumber}
                        onChange={setDownloaderNumber}
                      />
                      {downloaderNumberErr && downloaderNumberErr === true ? (
                        <span className="text-danger">
                          {" "}
                          {vallidationErr.downloaderNumber}{" "}
                        </span>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="col-sm-6  pt-3 pb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="inputPassword"
                      placeholder="Country"
                      name="downloaderCountry"
                      value={downloaderCountry}
                      onChange={handleChange}
                    />
                    {downloaderCountryErr && downloaderCountryErr === true ? (
                      <span className="text-danger">
                        {" "}
                        {vallidationErr.downloaderCountry}{" "}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="col-sm-12  pt-3 pb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="inputPassword"
                      placeholder="Contact(Skype,Whatsapp,Telegram)"
                      name="downloaderId"
                      value={downloaderId}
                      onChange={handleChange}
                    />
                    {downloaderIdErr && downloaderIdErr === true ? (
                      <span className="text-danger">
                        {" "}
                        {vallidationErr.downloaderId}{" "}
                      </span>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div></div>
                <div className="pt-3 pb-0 mt-1 banner_text_section footer_form_d">
                  <a target="_blank">
                    <Button onClick={Submit}>DownLoad</Button>
                  </a>
                </div>
              </form>
            </div>
          </div>

          <div className="col-lg-4">
            <div className="popup_headeine">
              <h2>{bookName}</h2>
              <p>
                {/* If you are curious for more details, 
                    check out other e-books similar to the previous book that briefly explain all our company services to know more about our company and services expertise.
                     Click here to download.  */}
                {bookDescription}
              </p>
            </div>
            <div className="imgae_CTA_section">
              <img src={bookImage} />
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default Book;
